module.exports = __webpack_public_path__ + "static/img/regina3.7c92f1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/regina3.jpg
// module id = 128
// module chunks = 9